import { createFileRoute } from '@tanstack/react-router'
import EmployeeWallet from '@/features/employee-wallet'

export const Route = createFileRoute('/_authenticated/employee-wallet/')({
  component: EmployeeWallet,
})
